import React from "react";
import "./Departments.css";

const KrushiVibhag = () => {
  return (
    <div className="dept-page">

      {/* TOP STRIP */}
      <div className="dept-top-strip">
        <span>🏛 महाराष्ट्र शासन</span>
        <span>कृषी विभाग</span>
      </div>

      {/* HEADER */}
      <header className="dept-header">

        <div className="dept-header-emblem">
          🌾
        </div>

        <div className="dept-header-text">

          <div className="dept-header-org">
            जिल्हा परिषद विभाग
          </div>

          <h1 className="dept-header-title">
            कृषी विभाग
          </h1>

          <div className="dept-header-subtitle">
            कृषि विकास व शेतकरी कल्याण
          </div>

        </div>

        <div className="dept-header-badge">
          AGRICULTURE DEPARTMENT
        </div>

      </header>

      {/* NAVIGATION */}
      <div className="dept-nav">

        <button className="dept-nav-tab active">
          विभाग माहिती
        </button>

        <button className="dept-nav-tab">
          योजना
        </button>

        <button className="dept-nav-tab">
          अनुदान
        </button>

        <button className="dept-nav-tab">
          संपर्क
        </button>

      </div>

      {/* MAIN */}
      <main className="dept-main">

        {/* HERO */}
        <section className="dept-intro">

          <div className="dept-intro-label">
            कृषि विकास व शेतकरी सक्षमीकरण
          </div>

          <p className="dept-intro-text">
            <strong>कृषी विभाग</strong> हा शेतकऱ्यांच्या आर्थिक
            प्रगतीसाठी, कृषि उत्पादन वाढीसाठी व आधुनिक
            शेती तंत्रज्ञानाचा प्रसार करण्यासाठी कार्यरत आहे.
            हरितक्रांतीनंतर सुधारित बियाणे, सिंचन, खते,
            कीटकनाशके व वैज्ञानिक शेती पद्धतींचा वापर
            वाढवून कृषि विकासाला चालना देण्यात आली.
            व्यापारक्षम शेती, कृषि प्रक्रिया उद्योग,
            फलोत्पादन व निर्यातवृद्धी यांना प्रोत्साहन देऊन
            शेतकऱ्यांना अधिकाधिक आर्थिक फायदा मिळवून
            देणे हे विभागाचे प्रमुख उद्दिष्ट आहे.
          </p>

        </section>

        {/* STATS */}
        <section className="dept-stats">

          <div className="dept-stat-card">
            <div className="dept-stat-value">13</div>
            <div className="dept-stat-label">
              तालुके
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">15.6L</div>
            <div className="dept-stat-label">
              भौगोलिक क्षेत्र (हे.)
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">9.9L</div>
            <div className="dept-stat-label">
              लागवडीखालील क्षेत्र
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">845.8</div>
            <div className="dept-stat-label">
              सरासरी पर्जन्यमान (मिमी)
            </div>
          </div>

        </section>

        {/* LEFT CONTENT */}
        <div>

          {/* AGRI INFO */}
          <section className="dept-section">

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🌱
              </div>

              <h2 className="dept-section-title">
                कृषि विभागाची भूमिका
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  आधुनिक शेती तंत्रज्ञान
                </div>

                <div className="scheme-card-desc">
                  कृषि विद्यापीठातील सुधारित तंत्रज्ञान
                  शेतकऱ्यांपर्यंत पोहोचविण्यासाठी
                  विविध कार्यक्रम राबविले जातात.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  पीक प्रात्यक्षिके व प्रशिक्षण
                </div>

                <div className="scheme-card-desc">
                  प्रक्षेत्र भेटी, चर्चासत्रे,
                  मेळावे व प्रदर्शने यांद्वारे
                  शेतकऱ्यांना मार्गदर्शन केले जाते.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  व्यापारक्षम शेती
                </div>

                <div className="scheme-card-desc">
                  कृषि उत्पादन वाढ, निर्यातवृद्धी
                  व कृषि प्रक्रिया उद्योगांना
                  प्रोत्साहन देण्यात येते.
                </div>

              </div>

            </div>

          </section>

          {/* CROPPING */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🌾
              </div>

              <h2 className="dept-section-title">
                हंगामनिहाय पीक क्षेत्र
              </h2>

            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                खरीप – 1,95,710 हे.
              </div>

              <div className="dept-service-item">
                रब्बी – 2,29,712 हे.
              </div>

              <div className="dept-service-item">
                उन्हाळी – 11,094 हे.
              </div>

              <div className="dept-service-item">
                उष्ण व कोरडे हवामान
              </div>

              <div className="dept-service-item">
                सरासरी पाऊस 845.8 मिमी
              </div>

              <div className="dept-service-item">
                नैऋत्य मोसमी वारे
              </div>

            </div>

          </section>

          {/* SCHEMES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                📋
              </div>

              <h2 className="dept-section-title">
                कृषि विभागाच्या योजना
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  डॉ. बाबासाहेब आंबेडकर कृषि स्वावलंबन योजना
                </div>

                <div className="scheme-card-desc">
                  अनुसूचित जातीतील शेतकऱ्यांसाठी
                  कृषि विकास व सिंचन सुविधा उपलब्ध करून देणारी योजना.
                </div>

                <div className="scheme-card-amount">
                  जिल्हा वार्षिक योजना
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  बिरसा मुंडा कृषि क्रांती योजना
                </div>

                <div className="scheme-card-desc">
                  अनुसूचित जमातीतील लाभार्थ्यांसाठी
                  सिंचन व कृषि विकासासाठी सहाय्य.
                </div>

                <div className="scheme-card-amount">
                  क्षेत्रांतर्गत / क्षेत्राबाहेरील
                </div>

              </div>

            </div>

          </section>

          {/* SUBSIDY */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💰
              </div>

              <h2 className="dept-section-title">
                अनुदान बाबी
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">
                <div className="scheme-card-name">
                  नवीन सिंचन विहीर
                </div>

                <div className="scheme-card-amount">
                  ₹ 4,00,000
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  जुनी विहीर दुरुस्ती
                </div>

                <div className="scheme-card-amount">
                  ₹ 1,00,000
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  सोलर पंप
                </div>

                <div className="scheme-card-amount">
                  ₹ 50,000
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  ठिबक सिंचन संच
                </div>

                <div className="scheme-card-amount">
                  ₹ 97,000
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  तुषार सिंचन संच
                </div>

                <div className="scheme-card-amount">
                  ₹ 47,000
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  यंत्रसामुग्री
                </div>

                <div className="scheme-card-amount">
                  ₹ 50,000
                </div>
              </div>

            </div>

          </section>

          {/* QUALITY CONTROL */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🔍
              </div>

              <h2 className="dept-section-title">
                गुणवत्ता नियंत्रण विभाग
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  निविष्ठा तपासणी
                </div>

                <div className="scheme-card-desc">
                  बियाणे, खते व कीटकनाशकांचे नमुने
                  तपासून गुणवत्ता सुनिश्चित केली जाते.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  विक्री केंद्र तपासणी
                </div>

                <div className="scheme-card-desc">
                  उत्पादन केंद्र, प्रयोगशाळा,
                  साठवणूक व विक्री केंद्रांची तपासणी केली जाते.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  तक्रार निवारण कक्ष
                </div>

                <div className="scheme-card-desc">
                  जिल्हा व तालुका स्तरावर
                  तक्रार निवारण कक्ष स्थापन करण्यात आले आहेत.
                </div>

              </div>

            </div>

          </section>

        </div>

        {/* SIDEBAR */}
        <aside className="dept-sidebar">

          {/* INFO CARD */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              जिल्हा माहिती
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                तालुके
              </div>

              <div className="dept-info-val">
                13
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                भौगोलिक क्षेत्र
              </div>

              <div className="dept-info-val">
                15,62,018 हे.
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                लागवडीखालील क्षेत्र
              </div>

              <div className="dept-info-val">
                9,91,787 हे.
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                सरासरी पाऊस
              </div>

              <div className="dept-info-val">
                845.8 मिमी
              </div>
            </div>

          </div>

          {/* CONTACT */}
          <div className="dept-contact-card">

            <div className="dept-contact-card-title">
              महत्त्वाच्या वेबसाईट्स
            </div>

            <div className="dept-contact-row">
              <span>🌐</span>
              <span>
                krishi.maharashtra.gov.in
              </span>
            </div>

            <div className="dept-contact-row">
              <span>🌐</span>
              <span>
                mahadbt.maharashtra.gov.in
              </span>
            </div>

            <div className="dept-contact-row">
              <span>🌐</span>
              <span>
                aaplesarkar.mahaonline.gov.in
              </span>
            </div>

          </div>

          {/* QUICK SERVICES */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              प्रमुख सेवा
            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                पीक मार्गदर्शन
              </div>

              <div className="dept-service-item">
                सिंचन योजना
              </div>

              <div className="dept-service-item">
                खत तपासणी
              </div>

              <div className="dept-service-item">
                कृषी प्रशिक्षण
              </div>

              <div className="dept-service-item">
                अनुदान योजना
              </div>

              <div className="dept-service-item">
                तक्रार निवारण
              </div>

            </div>

          </div>

        </aside>

      </main>

      {/* FOOTER */}
      <footer className="dept-footer">
        <strong>कृषी विभाग</strong>
        {" "}• जिल्हा परिषद प्रशासन
      </footer>

    </div>
  );
};

export default KrushiVibhag;